<alaris-card [alarisLoadingStub]="showLoadingStub">
	@if (tRows.length > 0 || (tRows.length === 0 && isFiltersApplied)) {
		<div class="table-management">
			<div class="left">
				<span class="total" data-testid="total"> {{ totalTitle | translate }}: {{ total }} </span>
				<alaris-select2
					[displayWith]="displayStatus"
					[formControl]="statusControl"
					class="status-filter"
					data-testid="statusSelect"
					size="md"
				>
					@for (opt of statuses; track $index) {
						<alaris-options2 [attr.data-testid]="'statusOption/' + opt" [value]="opt">
							{{ displayStatus(opt) | translate }}
						</alaris-options2>
					}
				</alaris-select2>
				<button (click)="editTableFilter()" alaris-button bType="outline" data-testid="editFilterBtn" size="lg">
					<alaris-icon name="icon-filter-vertical"></alaris-icon>
					{{ 'gl.filter.filters' | translate }}
					@if (state.isFiltersApplied) {
						<div class="indicator"></div>
					}
				</button>
				<alaris-link type="secondary" [underline]="false" (click)="editTableSettings()" data-testid="editSettingsLink">
					{{ 'table.settings.tableSettings' | translate }}
				</alaris-link>
			</div>
			<div class="right">
				<button
					(click)="refresh()"
					[alarisTooltip]="'actions.refreshPage' | translate"
					[offsetY]="-6"
					alarisIconButton
					bType="outline"
					data-testid="refreshBtn"
					size="lg"
				>
					<alaris-icon name="icon-refresh-clock-wise"></alaris-icon>
				</button>
				<ng-container *alarisPBAC="[CP_PERMISSIONS.CAMPAIGNS_E]">
					<button (click)="import.call(this)" alaris-button bType="outline" data-testid="fromFileBtn" size="lg">
						<alaris-icon name="icon-import"></alaris-icon>
						{{ 'campaigns.campaignFromFile' | translate }}
					</button>
					<button (click)="create.call(this)" alaris-button bType="primary" data-testid="createBtn" size="lg">
						<alaris-icon class="in-primary" name="icon-plus"></alaris-icon>
						{{ 'campaigns.newCampaign' | translate }}
					</button>
				</ng-container>
			</div>
		</div>
	}
	<div [alarisLoading]="loading$" class="content">
		@if (tRows.length === 0 && !isFiltersApplied) {
			<ng-content select="[slot=empty]"></ng-content>
		} @else {
			<alaris-table
				#tableRef
				(filtersChange)="_applyFilter($event)"
				(sortingChange)="_applySorting($event)"
				[colSpan]="false"
				[ctxActions]="ctxActions"
				[dblClickRowAction]="dblClickRowAction.bind(this)"
				[disabledRows]="disabledRows"
				[dropDownRowActions]="dropDownRowActions"
				[expandable]="true"
				[expanded]="expandedRows()"
				[expandedRowTemplate]="expandedRowTemplate"
				[filters]="state.filters()"
				[fixFirstColumn]="fixFirstColumn"
				[resizable]="resizable"
				[rowActions]="rowActions"
				[showNoFilterResult]="showNoFilterResult"
				[sorting]="state.sorting()"
				[trackColumnsWidth]="true"
				[tHeaders]="tHeaders()"
				[tRows]="tRows"
				[tSettings]="tSettings()"
				[templates]="templates"
				alarisOverflowFader
				class="campaigns-table"
			>
				<alaris-no-filter-result
					slot="no-filter-result"
					imageUrl="assets/img/no-campaigns.webp"
					(clearFilter)="_clearFilter()"
				/>
			</alaris-table>

			<ng-template
				#expandedRowTemplate
				[alarisExpandedCellCtx]="tRows[0]"
				let-element
				let-resizingColumn="resizingColumn"
			>
				<tr>
					<td [colSpan]="tHeaders().length">
						<div #expandedTableContainerEl class="recurrent-table-container">
							<table>
								<tbody>
									@for (campaign of element.recurrentHistory || []; track $index) {
										<tr
											(dblclick)="dblClickRowAction(campaign)"
											[attr.data-testid]="'row/' + campaign.id"
											[cdkContextMenuTriggerFor]="ctxMenu"
											[dropDownRowActions]="dropDownRowActions"
											[rowActions]="rowActions"
											[row]="campaign"
											[tableContainerEl]="tableRef.elementRef.nativeElement"
											[expandedTableContainerEl]="expandedTableContainerEl"
											alarisRowActions
											class="expanded-row"
										>
											@for (head of tHeaders(); let columnIndex = $index; track columnIndex) {
												@let settings = tSettingsMap().get(head.variable);
												<td
													[class.resizing]="resizingColumn === columnIndex"
													[style.display]="settings ? (settings.visible ? '' : 'none') : ''"
													[style.width]="'var(--column-' + columnIndex + ')'"
												>
													@if (head.variable !== 'campaign') {
														<ng-container
															*ngTemplateOutlet="
																templates[head.variable] || defaultTemplate;
																context: { data: campaign, key: head.variable }
															"
														>
														</ng-container>
													}
												</td>
											}
										</tr>
										<ng-template #ctxMenu>
											@if (ctxActions.length) {
												<alaris-ctx-action
													[actions]="ctxActions"
													[attr.data-testid]="'ctxActions/' + campaign.id"
													[row]="campaign"
												>
												</alaris-ctx-action>
											}
										</ng-template>
									}
								</tbody>
							</table>
						</div>
					</td>
				</tr>
			</ng-template>
		}
	</div>
	<div class="footer">
		<alaris-pagination
			(page)="_pageChange($event)"
			[activePage]="activePage"
			[hidden]="total === 0"
			[pageSizeOptions]="pageSizeOptions"
			[pageSize]="pageSize"
			[total]="total"
			class="pagination"
		>
		</alaris-pagination>
	</div>
</alaris-card>

<ng-template #defaultTemplate let-data="data" let-key="key">
	{{ data[key] }}
</ng-template>
